import {
  Collapse,
  Divider,
  Grid,
  Typography,
} from "@mui/material";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@mui/styles";
import cssVariables from "../../theme/cssVariables";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const ExpandingList = (props) => {
  const useStyles = makeStyles({
    expandableIcon: {
      background: "#F5F5F5",
      // padding: 3,
      width: '20px',
      height: '20px',
      borderRadius: 3,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transition: '.3s',
      '&.active': {
        transform: "rotate(90deg)",
      }
    },
  });
  const classes = useStyles();
  // const [isExpanding, setExpanding] = React.useState(false);
  const handleClick = () => {
    props.toggleSelected(props.data)
  }
  return ( 
    <Grid container spacing={4}>
      <Grid item lg={12} mt="32px" sx={{paddingTop: "0!important"}}>
        <Grid container py={1}>
          <Grid item lg={1} onClick={handleClick}>
            <div className={`clickable ${classes.expandableIcon} ${ props.selected ? 'active' : ''}`}><ArrowForwardIosIcon sx={{ fontSize: "0.9rem" }} /></div>
          </Grid>
          <Grid item lg={11}>
            <Typography fontSize={20} lineHeight="22px" fontWeight="400">{props.data.title}</Typography>
          </Grid>
        </Grid>
        <Collapse in={props.selected} timeout="auto">
          {props.item}
        </Collapse>
      </Grid>
    </Grid>
  )
}

export default ExpandingList;
